import React, {ReactNode} from 'react';

import cs from 'classnames';
import styled from 'styled-components';

import {ProcedureStepNumber} from 'app/procedures/components/ProcedureStepNumber';
import {getStepName} from 'app/utils/fallbacks';

interface Props {
  type?: 'content' | 'decision' | 'ending' | 'processprocedure' | 'automation';
  n: number;
  title?: string;
  fixedWidth?: boolean;
  titleContainer?: (title: ReactNode) => ReactNode;
}

export function InlineStepNumberedTitle({
  n,
  type,
  title,
  fixedWidth,
  titleContainer,
}: Props) {
  const normalizedTitle = getStepName({title, type}, true);

  return (
    <InlineStepNumberedTitleStructure
      fixedWidth={fixedWidth}
      icon={<ProcedureStepNumber n={n} type={type} />}
      title={titleContainer?.(normalizedTitle) ?? normalizedTitle}
    />
  );
}
interface StructureProps {
  icon: ReactNode;
  title: ReactNode;
  fixedWidth?: boolean;
}
export function InlineStepNumberedTitleStructure({
  icon,
  title,
  fixedWidth = false,
}: StructureProps) {
  return (
    <div className="d-flex align-items-center">
      <StyledNumberContainerDiv
        className={cs({
          fw: fixedWidth,
        })}
      >
        {icon}
      </StyledNumberContainerDiv>
      {title}
    </div>
  );
}

const StyledNumberContainerDiv = styled.div.attrs<{className?: string}>({
  className: 'd-flex align-items-center justify-content-center mr-1',
})`
  &.fw {
    width: 1.6rem;
  }
`;
